module.exports = __webpack_public_path__ + "static/media/changelog.d669a253.svg";